import {StyleSheet} from 'react-native';
import Typography from '../../../../shared/constants/Typography';
import {palette} from '../../../../shared/theme/colorGroups/palette.colors';

/**
 * @param isZoomed extreme browser zoom (e.g. 320 px wide at 400%): the text input
 *   has an intrinsic minimum width that pushes the submit arrow out of the
 *   bordered box, so every flex child is allowed to shrink (min-width 0) and the
 *   arrow / clear buttons never shrink. Never true at normal zoom or on native.
 */
export const createSearchInputStyles = (theme: any, isZoomed: boolean = false) =>
  StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'row',
      backgroundColor: theme.backgroundColor,
      borderRadius: Typography.radius.radius8,
      paddingLeft: Typography.padding.padding12,
      borderColor: theme.borderColor,
      borderWidth: Typography.borderWidth.borderWidth1,
      alignItems: Typography.textAlign.centerAlign,
      maxHeight: Typography.height.dropDownheight,
      height: Typography.height.dropDownheight,
      // flex:1 above lets a column parent squeeze the box shorter than the
      // 44 px arrow button next to it when vertical space is tight (misaligned).
      ...(isZoomed && {
        minWidth: 0,
        maxWidth: '100%',
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 'auto',
        minHeight: Typography.height.dropDownheight,
      }),
    },
    leftContainer: {
      flexDirection: 'row',
      gap: Typography.gap.gap8,
      ...(isZoomed && {flexShrink: 0}),
    },
    closeIcon: {
      alignItems: Typography.textAlign.centerAlign,
      maxHeight: Typography.height.dropDownheight,
      flexDirection: 'row',
    },
    rightView: {
      flex: 1,
      flexDirection: 'row',
      paddingLeft: Typography.padding.padding12,
      gap: Typography.gap.gap4,
      alignItems: Typography.textAlign.centerAlign,
      ...(isZoomed && {minWidth: 0}),
    },
    input: {
      flex: 1,
      ...(isZoomed && {minWidth: 0, width: '100%'}),
      fontSize: Typography.fontSize.fontSize14,
      color: theme.inputColor,
      fontFamily: Typography.fontFamily.inter,
      height: Typography.height.dropDownheight,
      fontWeight: Typography.fontWeight.regular,
    },
    innerContainer: {
      flex: 1,
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap4,
      ...(isZoomed && {minWidth: 0}),
    },
    sortDropdown: {
      minWidth: Typography.width.width80,
      flexShrink: 0,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderLeftWidth: 0,
      borderBottomLeftRadius: Typography.radius.radius8
    },
    borderDropdown: {
      borderBottomLeftRadius: Typography.radius.radius8
    },
    dropdownText: {
      fontSize: Typography.fontSize.fontSize14,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.medium,
      lineHeight: Typography.lineHeight.lineHeight20,
      color: theme.searchResultColor,
    },
    customLabelStyle: {
      fontSize: Typography.fontSize.fontSize14,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.medium,
      lineHeight: Typography.lineHeight.lineHeight20,
    },
    searchArrow: {
      height: Typography.height.dropDownheight,
      backgroundColor: theme.searchResultBGColor,
      borderColor: theme.borderColor,
      borderRightColor: 'transparent',
      borderRadius: Typography.radius.radius8,
      borderWidth: Typography.borderWidth.borderWidth1,
      width: Typography.width.width40,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0,
      margin: 0,
    },
    enableSearchArrow: {
      borderColor: theme.activeBorderColor,
      // borderBottomColor: theme.activeBorderColor,
    },
    enableSearchHoverArrow: {
      borderColor: theme.hoverBorderColor,
      // borderBottomColor: theme.hoverBorderColor,
    },
    // ── External search button (shown when showSearchButton=true) ─────────────
    outerWrapper: {
      flexDirection: Typography.flexDirection.row,
      alignItems: Typography.textAlign.centerAlign,
      gap: 15,
    },
    searchButton: {
      height: Typography.height.dropDownheight,
      backgroundColor: palette.blue.selectedText,
      borderRadius: Typography.radius.radius8,
      paddingHorizontal: Typography.padding.padding12,
      gap: Typography.gap.gap10,
      flexDirection: Typography.flexDirection.row,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
    },
    searchButtonText: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      fontFamily: Typography.fontFamily.inter,
      color: palette.gray.white,
      lineHeight: Typography.lineHeight.lineHeight14,
    },
    searchButtonDisabled: {
      backgroundColor: theme.bGDisableColor,
      borderColor: 'transparent',
    },
    searchButtonTextDisabled: {
      color: theme.textDisableColor,
    },
  });
